import { useState, useEffect } from "react";

/**
 * Returns true when window has been scrolled past `threshold` pixels.
 * Useful for shrink-on-scroll navbars.
 */
export const useScrolled = (threshold = 20) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setIsScrolled(window.scrollY > threshold);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, [threshold]);

  return isScrolled;
};
